import { trackCustomEvent } from "./customEvents";
import { currentRegionFromMetaTag } from "../currentRegionFromMetaTag";
import { commissioningRegionFromMetaTag } from "../commissioningRegionFromMetaTag";
export function trackArticleViewed(contentId) {
    trackCustomEvent("articleViewed", {
        articleId: contentId.toString(),
        userEdition: currentRegionFromMetaTag(),
        commissioningEdition: commissioningRegionFromMetaTag(),
    });
}
